define('shared/initializer/form/adapters/mixins/LeadAfterSubmit',[
    'shared/lib/RSVP',
    'shared/lib/console',
    'shared/lib/URI',
    'shared/util/state',
    'shared/util/registers/ActionProvider',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/util/state/adapters/pending',
    'shared/initializer/form/constants',
    'shared/util/tracking/dailyLesson',
    'shared/util/tracking/pendingEvents'
],
function (
    RSVP,
    console,
    URI,
    state,
    ActionProvider,
    FormDataDispatcher,
    pendingAdapter,
    constants,
    dailyLessonUtil,
    pendingEventsUtil
) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doAfterSubmit = function( data ){
        var leadId = data.LeadId || data.Lead_id;

        var me = this;
        return RSVP.resolve()
        .then(function(){
            return new RSVP.Promise(function(resolve, reject){
                if ( leadId == null ) {
                    console.error('Faulty data returned from server:', data);
                    reject('Server returned incompatible data, no LeadId was found.');
                    return;
                }

                state.push('form.lead_id', leadId).then(resolve, reject);
            });
        })
        .then(function(){
            var target = me.$form.find('input[name=' + constants.FIELD.OnSuccessUrl + ']').val();
            if (!target || target === '#') {
                return;
            }

            if (me.options && me.options.redirection) {
                for( var key in me.options.redirection ) {
                    if ( me.options.redirection.hasOwnProperty(key) === false ) {
                        continue;
                    }

                    var rules = me.options.redirection[key];
                    var val = me.$form.find('[name=' + key + ']').val();
                    var range;

                    if ( val == null || val == false ) {
                        continue;
                    }

                    // parse range
                    var REGEX_RANGE = /^\d*?\-|\<|\>\d*/;
                    if ( REGEX_RANGE.test(val) ) {
                        range = val.split(/\-|\<|\>/);
                        if ( val.indexOf('>') >=0 ) {
                            range = val.split('>');
                            range[0] ^= range[1];
                            range[1] ^= range[0];
                            range[0] ^= range[1];
                        }
                    }

                    if (range[0] == null || range[0] == "") {
                        range[0] = 0;
                    }

                    if (range[1] == null || range[1] == "") {
                        range[1] = 999;
                    }

                    range[0] = range[0] >> 0;
                    range[1] = range[1] >> 0;

                    for( var k = rules.length; k--; ) {
                        var rule = rules[k];

                        if ( 'operator' in rule && range != null && rule.action != null ) {
                            var result = eval(
                                'true?(' +
                                range[0] + rule.operator + rule.value + '&&' +
                                range[1] + rule.operator + rule.value +
                                '):null'
                            );
                            if ( result ) {
                                target = rule.action;
                            }
                        }
                    }
                }
            }

            me.nextPageUrl = target;
        })
        .then(function(){
            if(leadId && leadId > 0){
                return pendingEventsUtil.add(constants.EVENT.LeadOnlineEnquiry);
            }
            else{
                return RSVP.resolve();
            }
        })
        .then(function() {
            if (dailyLessonUtil.dailyLessonSubscribed.apply(me)) {
                return pendingEventsUtil.add(constants.EVENT.EmailEnglish);
            }
            else {
                return RSVP.resolve();
            }
        });
    };

    return Ctor;
});

